import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AttachmentService } from './attachment.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { AppMessages } from '../../../shared/constants/messages';
import { Utility } from '../../../common/utility';
@Component({
  selector: 'ch-attachment',
  templateUrl: 'attachment.component.html',
  providers: [AttachmentService],
})

export class AttachmentComponent implements OnInit, OnChanges {
  @Input() consultationId: string;
  @Input() patientId: string;
  @Input() history: boolean;
  @Input() height: number;
  public klass = 'consultationhistory';
  public attachmentFile: File = null;
  public attachments: any[];
  constructor(public attachmentService: AttachmentService,
    public dialogService: DialogService) { }

  ngOnInit() {
    this.height = this.height ? (this.height > 600 ? this.height - 172 : this.height - 185) : null;
    // this.getConsultationAttachment();
  }

  ngOnChanges(ev: SimpleChanges) {
    this.getConsultationAttachment();
    // if (ev) {
    //   if (ev['consultationId']) {
    //     if (ev['consultationId'].currentValue) {
    //       this.getConsultationAttachment();
    //     }
    //   }
    // }
  }

  getConsultationAttachment() {
    this.attachmentService.getConsultationAttachment(this.consultationId, this.patientId).subscribe(
      (result) => {
        if (result) {
          this.attachments = result.json();
        }
      }
    );
  }


  uploadAttachment() {
    if (this.attachmentFile) {
      const formData = new FormData();
      formData.append('uploadFile', this.attachmentFile, this.attachmentFile.name);
      this.attachmentService.uploadAttachment(this.consultationId, formData).subscribe(result => {
        if (result) {
          this.attachmentFile = null;
          this.getConsultationAttachment();
        }
      }
      );
    }
  }

  removeAttachment(id: string) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.groupTemplateConsultant.removeAttachment }).subscribe(result => {
      if (result) {
        this.attachmentService.removeAttachment(id).subscribe(res => {
          if (res) {
            this.getConsultationAttachment();
          }
        }
        );
      }
    });
  }

  onChangeAttachment(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.attachmentFile = file;
    }
  }

  sharedToggle(attachment: any) {
    if (attachment) {
      if (attachment.isShared === null || attachment.isShared === undefined) {
        attachment.isShared = false;
      }
      this.setShareStatus(attachment);
    }
  }


  setShareStatus(attachment) {
    if (attachment) {
      this.dialogService.openConfirmationDialog(
        { message: attachment.isShared ? AppMessages.document.unShared : AppMessages.document.isShared }).subscribe(res => {
          if (res) {
            // call api set shared status
            this.attachmentService.setShareStatus(attachment.id, !attachment.isShared).subscribe(result => {
              if (result) {
                const data = result.json();
                attachment.isShared = data.isShared;
              }
            });
          }
        });
    }
  }

  viewDownloadFile(attachmentFile: any) {
    if (attachmentFile) {
      // attachment.id
      this.attachmentService.downloadFile(attachmentFile.id)
        .map(res => {
          return {
            filename: attachmentFile.fileName,
            data: res.blob()
          };
        })
        .subscribe(res => {
          //console.log('start download:',res);

          if (attachmentFile.fileName.toLowerCase().indexOf(".pdf") != -1) {
            
            var url = window.URL.createObjectURL(res.data);
            var winTab = window.open("", "_blank");
            //Open URL by writing iframe with given URL
            winTab.document.write('<iframe src="'+ url + '" title="'+ attachmentFile.fileName +'" style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"></iframe>');

            //Set Title for the new tab
            winTab.document.title = attachmentFile.fileName;

            window.URL.revokeObjectURL(url);

            // a.remove(); // remove the element
          }
          else {
            var url = window.URL.createObjectURL(res.data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url + '#' + attachmentFile.fileName;
            a.download = res.filename;

            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }
        }, error => {
          console.log('download error:', JSON.stringify(error));
        }, () => {
          console.log('Completed file download.')
        });
    }
  }


  // support download pdf, View pdf can not download file
  downloadFile(attachmentFile: any) {
    if (attachmentFile) {
      // attachment.id
      this.attachmentService.downloadFile(attachmentFile.id)
        .map(res => {
          return {
            filename: attachmentFile.fileName,
            data: res.blob()
          };
        })
        .subscribe(res => {
          //console.log('start download:',res);
          var url = window.URL.createObjectURL(res.data);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = res.filename;

          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element

        }, error => {
          console.log('download error:', JSON.stringify(error));
        }, () => {
          console.log('Completed file download.')
        });
    }
  }

  sendEmailNotify(attachment) {
    this.attachmentService.getPatientEmail(this.patientId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.dialogService.openConfirmationDialog(
            { message: Utility.stringFormat(AppMessages.document.emailNotify, [data['patientEmail']]) }).subscribe(res => {
              if (res) {
                this.attachmentService.sendEmailNewUploadedDocuments(this.patientId, this.consultationId).subscribe(resEmail => {
                  if (resEmail) {
                    const resEmailData = resEmail.json();
                    this.dialogService.openSuccessDialog({ message: resEmailData.message })
                  }
                });
              }
            });
        }
      }
    )

  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/attachment/attachment.component.ts